'use strict';
var arraySlice = require('../internals/array-slice');

// https://tc39.github.io/proposal-setmap-offrom/
module.exports = function of() {
  return new this(arraySlice(arguments));
};



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/mea/node_modules/core-js/internals/collection-of.js
// module id = 200
// module chunks = 0